import axios from 'axios'

/** Raw REST for MvM pre-battle ops (used as socket ack fallback). */

export const restMvmWorldAttackPrecheck = async (
  walletAddress: string,
  targetOwnerWallet: string,
  extras?: {
    leaderCharacterCount?: number
    estimatedMarchTimeMs?: number
    worldId?: string
    castleSiegePrecheck?: boolean
  },
) => {
  const leaderCharacterCount = extras?.leaderCharacterCount
  const estimatedMarchTimeMs = extras?.estimatedMarchTimeMs
  const response = await axios.post('/mvm/world-attack-precheck', {
    walletAddress,
    targetOwnerWallet,
    ...(typeof leaderCharacterCount === 'number' && Number.isFinite(leaderCharacterCount)
      ? { leaderCharacterCount }
      : {}),
    ...(typeof estimatedMarchTimeMs === 'number' && Number.isFinite(estimatedMarchTimeMs)
      ? { estimatedMarchTimeMs }
      : {}),
    ...(extras?.worldId ? { worldId: extras.worldId } : {}),
    ...(extras?.castleSiegePrecheck ? { castleSiegePrecheck: true } : {}),
  })
  return response.data
}

export const restStartMvMAttack = async (
  walletAddress: string,
  targetOwnerWallet: string,
  fromQ: number,
  fromR: number,
  toQ: number,
  toR: number,
  selectedCharacterIds: string[],
  _abilityPoints?: unknown,
  characterTemplateIds?: string[],
  rallyMode?: boolean,
  rallyDurationMs?: number,
  worldId?: string,
  breadAmount?: number,
  clientRequestId?: string
) => {
  const response = await axios.post('/mvm/start-attack', {
    walletAddress,
    targetOwnerWallet,
    fromQ,
    fromR,
    toQ,
    toR,
    selectedCharacterIds,
    characterTemplateIds,
    rallyMode: !!rallyMode,
    ...(typeof rallyDurationMs === 'number' ? { rallyDurationMs } : {}),
    ...(worldId ? { worldId } : {}),
    ...(typeof breadAmount === 'number' && Number.isFinite(breadAmount) ? { breadAmount } : {}),
    ...(clientRequestId ? { clientRequestId } : {}),
  })
  return response.data
}

export const restMvmAttackArrived = async (walletAddress: string, attackId: string) => {
  const response = await axios.post('/mvm/attack-arrived', { walletAddress, attackId })
  return response.data
}

export const restMvmDefenderSelect = async (
  walletAddress: string,
  attackId: string,
  selectedCharacterIds: string[],
  _abilityPoints?: unknown,
  characterTemplateIds?: string[],
  breadAmount?: number
) => {
  const response = await axios.post('/mvm/defender-select', {
    walletAddress,
    attackId,
    selectedCharacterIds,
    characterTemplateIds,
    ...(typeof breadAmount === 'number' && Number.isFinite(breadAmount) ? { breadAmount } : {}),
  })
  return response.data
}

export const restMvmDefenderSelectAndConfirm = async (
  walletAddress: string,
  attackId: string,
  selectedCharacterIds: string[],
  _abilityPoints?: unknown,
  characterTemplateIds?: string[],
  breadAmount?: number
) => {
  const response = await axios.post('/mvm/defender-select-and-confirm', {
    walletAddress,
    attackId,
    selectedCharacterIds,
    characterTemplateIds,
    ...(typeof breadAmount === 'number' && Number.isFinite(breadAmount) ? { breadAmount } : {}),
  })
  return response.data
}

export const restMvmDefenderTowerMarch = async (
  walletAddress: string,
  attackId: string,
  selectedCharacterIds: string[],
  _abilityPoints?: unknown,
  characterTemplateIds?: string[],
  worldId?: string
) => {
  const response = await axios.post('/mvm/defender-tower-march', {
    walletAddress,
    attackId,
    selectedCharacterIds,
    characterTemplateIds,
    ...(worldId ? { worldId } : {}),
  })
  return response.data
}

export const restMvmCancelDefenderTowerMarch = async (walletAddress: string, attackId: string) => {
  const response = await axios.post('/mvm/defender-tower-march/cancel', { walletAddress, attackId })
  return response.data
}

export const restMvmConfirmBattle = async (walletAddress: string, attackId: string) => {
  const response = await axios.post('/mvm/confirm-battle', { walletAddress, attackId })
  return response.data
}

export const restMvmAutoDefend = async (walletAddress: string, attackId: string) => {
  const response = await axios.post('/mvm/auto-defend', { walletAddress, attackId })
  return response.data
}

export const restJoinMvMRally = async (
  walletAddress: string,
  attackId: string,
  selectedCharacterIds: string[],
  characterTemplateIds?: string[],
  abilityPoints?: unknown,
  breadAmount?: number
) => {
  const response = await axios.post('/mvm/rally/join', {
    walletAddress,
    attackId,
    selectedCharacterIds,
    characterTemplateIds,
    abilityPoints,
    ...(typeof breadAmount === 'number' && Number.isFinite(breadAmount) ? { breadAmount } : {}),
  })
  return response.data
}

export const restJoinMvMReinforcement = async (
  walletAddress: string,
  attackId: string,
  selectedCharacterIds: string[],
  characterTemplateIds?: string[],
  breadAmount?: number
) => {
  const response = await axios.post('/mvm/reinforce/join', {
    walletAddress,
    attackId,
    selectedCharacterIds,
    characterTemplateIds,
    ...(typeof breadAmount === 'number' && Number.isFinite(breadAmount) ? { breadAmount } : {}),
  })
  return response.data
}

export const restLeaveMvMRallyJoin = async (walletAddress: string, attackId: string) => {
  const response = await axios.post('/mvm/rally/leave', { walletAddress, attackId })
  return response.data
}

export const restLeaveMvMReinforcement = async (walletAddress: string, attackId: string) => {
  const response = await axios.post('/mvm/reinforce/leave', { walletAddress, attackId })
  return response.data
}

export const restRequestDefenseHelp = async (walletAddress: string, attackId: string) => {
  const response = await axios.post('/mvm/request-defense-help', { walletAddress, attackId })
  return response.data
}

export const restCancelMvMAttackByAttacker = async (walletAddress: string, attackId: string) => {
  const response = await axios.post('/mvm/cancel-attack', { walletAddress, attackId })
  return response.data
}

/** Live battles this wallet is a participant of (Enter-battlefield markers). */
export const restMvmMyBattles = async (walletAddress: string) => {
  const response = await axios.get('/mvm/my-battles', { params: { walletAddress } })
  return response.data
}
